<template>
  <div class="chat-text-input">
    <input type="text" v-model="value" :placeholder="placeholder" />
  </div>
</template>

<script>
export default {
  name: 'ChatText',

  data() {
    return {
      value: ''
    }
  },

  props: {
    placeholder: String
  },

  watch: {
    value(answer) {
      this.$emit('input', answer)
    }
  },

  methods: {
    clearValue() {
      this.value = ''
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.chat-text-input
  input[type=text]
    width: 100%
    padding: 6px
    border-radius: 3px
    height: 100%
    font-size: 18px
    border: 1px solid #ccc
    margin: $gap-small 0

    @include media($media-gt-x-large)
      width: calc(100% - #{$gap-small})
      margin: 0

    &:focus
      outline: none
      border: 1px solid

      @include themify($themes)
        border-color: themed('color-secondary')
</style>
